<template>
  <div>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="field">
            <p><router-link v-bind:to="'/clients/create'" class="button is-info">Create new application</router-link></p>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.clientsTotal | numberDisplay }}</strong> applications</p>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Platform</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.clients.length">
          <td colspan="5" class="has-text-centered has-text-grey">No applications found</td>
        </tr>
        <tr v-for="item in this.$store.state.clients">
          <td>{{ item.id }}</td>
          <td><router-link v-bind:to="`/clients/${item.id}`">{{ item.name }}</router-link></td>
          <td>{{ item.platform }}</td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.clientsTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      }
    },

    created () {
      this.$store.dispatch('getOrganizationClients', {
        organizationId: this.$store.state.organizationId,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getOrganizationClients', {
          organizationId: this.$store.state.organizationId,
          params: this.$route.query
        })
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// ClientList.vue?a714671c